export default __webpack_public_path__ + "static/media/moraTtsIt_It60.757dbc85.mp3";